import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class BsCompanyLocationItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            inner: '.m-bsCompanyLocationItem__inner',
            name: '.m-bsCompanyLocationItem__name',
            street: '.m-bsCompanyLocationItem__street',
            address: '.m-bsCompanyLocationItem__address',
            link: '.m-bsCompanyLocationItem__link',
            telephone: '.m-bsCompanyLocationItem__phoneNumber',
            fax: '.m-bsCompanyLocationItem__fax',
        };
    }

    getPropsFromDom() {
        return {
            active: !!this.dom.inner,
            companyName: this.dom.name ? this.dom.name.innerText : '',
            street: this.dom.street ? this.dom.street.innerText : '',
            address: this.dom.address ? this.dom.address.innerText : '',
            telephone: this.dom.telephone ? this.dom.telephone.innerHTML : '',
            fax: this.dom.fax ? this.dom.fax.innerHTML : '',
            hasRoute: !!this.dom.link,
            hasCoordinates: this.dom.link ? this.dom.link.getAttribute('data-lat') : '',
            mapsCompanyName: this.dom.link ? this.dom.link.getAttribute('data-maps-company-name') : '',
            mapsStreet: this.dom.link ? this.dom.link.getAttribute('data-maps-street') : '',
            mapsAddress: this.dom.link ? this.dom.link.getAttribute('data-maps-address') : '',
            lat: this.dom.link ? this.dom.link.getAttribute('data-lat') : '',
            lng: this.dom.link ? this.dom.link.getAttribute('data-lng') : '',
        };
    }
}
